import { render, staticRenderFns } from "./Temporary.vue?vue&type=template&id=5ffd1611&"
import script from "./Temporary.vue?vue&type=script&lang=js&"
export * from "./Temporary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports